module.exports = __webpack_public_path__ + "img/antes_despues_89.55b16b95.png";